module.exports = __webpack_public_path__ + "img/journal-medical.1c30cfc4.svg";